import { cn } from "@/lib/utils"
import { useState } from "react"

interface EditableRowProps {
  label: string
  value: string
  onChange: (v: string) => void
  mono?: boolean
  multiline?: boolean
}

export function EditableRow({
  label,
  value,
  onChange,
  mono,
  multiline,
}: EditableRowProps) {
  const [focused, setFocused] = useState(false)
  const Tag = multiline ? "textarea" : "input"

  return (
    <div>
      <div className="mb-1.5 text-[11.5px] text-grey5">{label}</div>
      <Tag
        value={value}
        rows={multiline ? 2 : undefined}
        onChange={(e) => onChange(e.target.value)}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        className={cn(
          "w-full resize-none rounded-md border bg-grey2 text-white outline-hidden",
          "transition-[border-color,box-shadow] duration-150",
          mono ? "font-mono text-[12px]" : "font-sans text-[13px]",
          multiline ? "h-auto px-2.5 py-2" : "h-8 px-2.5",
          focused
            ? "border-yellow1 shadow-[0_0_0_3px_rgba(255,244,64,0.20)]"
            : "border-grey4",
        )}
      />
    </div>
  )
}
